// import scss
import "./scss/main.scss";

// import $ from "jquery";
import $ from "cash-dom"; // jQuery alternative
// import axios from 'axios'; // ajax http request lib
// import dayjs from 'dayjs'; // date manipulation lib
// import 'dayjs/locale/nl'; // locales for dayjs

$(document).ready(() => {
    console.log('hello at document ready!');

    $('.modal-background').on('click', (e) => {
        $(e.target).parent('div.modal').hide();
    });

    $(document).on('keydown', (e) => {
        console.info(e);
    });

    $('#toggle').on('click', () => {
        $('#mobile-menu').toggleClass('active');
        $('#toggle').toggleClass('x');
    });

    $(document).on('click', (e) => {
        let $target = $(e.target);

        if ($target.hasClass('x') || $target.parents('#toggle').length >= 1) {
            // console.info('target is menu button');
            return;
        }

        if ($target.hasClass('mobile-menu')) {
            // console.info('target is menu itself');
            return;
        }

        if (!$target.parents('.mobile-menu').length <= 0 && $('#mobile-menu').hasClass('active')) {
            $('#mobile-menu').removeClass('active');
            $('#toggle').removeClass('x');
            // console.info('remove class')
        }
    });

    $('.modal-link').on('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        const $target = $(e.target);
        console.info($target.attr('href'));

        $($target.attr('href')).show();
    })

    window.setTimeout(() => {
        $('div.alert-hide').hide();
    }, 10000)
});
